import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../../../models/utilities/document-request";
import { API_METHODS } from "../../../models/utilities/type-models";
import { ApiEndpoints } from "../../../utils/app-constants";
import { toCondensedDateTimeSeconds } from "../../../utils/date-utils";

export class DocumentProductionPaperworkByLine implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab : boolean = false;
    public url : string = ''; 
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'POST';
    public data: any;

    constructor(jobDictionary:  { [key: number]: number[] }) {        
        this.url = ApiEndpoints.PRODUCTION_JOBS_DOWNLOAD;
        this.data = { data: jobDictionary };

        this.filename = `Production_LinePaperwork_${ toCondensedDateTimeSeconds(new Date()) }`;
    }

}
